var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmortization(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5C2 4.44772 2.44772 4 3 4H20C20.5523 4 21 4.44772 21 5V9H22C22.5523 9 23 9.44772 23 10V14C23 14.5523 22.5523 15 22 15H21V19C21 19.5523 20.5523 20 20 20H3C2.44772 20 2 19.5523 2 19V5ZM21 13V11H15C14.4477 11 14 11.4477 14 12C14 12.5523 14.4477 13 15 13H21ZM19 9H15C13.3431 9 12 10.3431 12 12C12 13.6569 13.3431 15 15 15H19V18H4V6H19V9Z",
    fill: "#748EA0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmortization);
export default __webpack_public_path__ + "static/media/amortization.b74a7e8df2192172d7b4cb4261f61898.svg";
export { ForwardRef as ReactComponent };